import {
  ArrayListClassDesc2euexqfjnihq7 as ArrayListClassDesc,
  LinkedHashSetClassDesc202cqq5740j6e as LinkedHashSetClassDesc,
  LinkedHashMapClassDesc1yxtovbec4ruk as LinkedHashMapClassDesc,
  HashSetClassDesc1sva99tssxbb4 as HashSetClassDesc,
  HashMapClassDesc33bep136pd9y6 as HashMapClassDesc,
  ArrayClassDesc2voesact8ugbc as ArrayClassDesc,
  PrimitiveArrayDescriptor3bvg9e2uulc3b as PrimitiveArrayDescriptor,
} from './CollectionDescriptors.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { toNativeArrayImpl3ha7yn5cjhfpi as toNativeArrayImpl } from './Platform.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { PrimitiveKindndgbuh6is7ze as PrimitiveKind } from '../descriptors/SerialKinds.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ArrayListSerializerClass;
function ArrayListSerializer() {
  if (ArrayListSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(element) {
        super(element);
        this.descriptor_1 = new (ArrayListClassDesc())(element.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      builder_3thy1n_k$() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      builderSize_y2o8s8_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_size_woubt6_k$();
      }
      builderSize_wan9ya_k$(_this__u8e3s4) {
        return this.builderSize_y2o8s8_k$(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_fpl6ik_k$(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      toResult_x7ydem_k$(_this__u8e3s4) {
        return this.toResult_fpl6ik_k$(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_unwgi5_k$(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? ArrayList().new_kotlin_collections_ArrayList_603np_k$(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_unwgi5_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      checkCapacity_qq1vqe_k$(_this__u8e3s4, size) {
        return _this__u8e3s4.ensureCapacity_wr7980_k$(size);
      }
      checkCapacity_4ljkg0_k$(_this__u8e3s4, size) {
        return this.checkCapacity_qq1vqe_k$(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      insert_irgt39_k$(_this__u8e3s4, index, element) {
        _this__u8e3s4.add_dl6gt3_k$(index, element);
      }
      insert_rt7dry_k$(_this__u8e3s4, index, element) {
        return this.insert_irgt39_k$(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ArrayListSerializer');
    ArrayListSerializerClass = $;
  }
  return ArrayListSerializerClass;
}
var LinkedHashSetSerializerClass;
function LinkedHashSetSerializer() {
  if (LinkedHashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.descriptor_1 = new (LinkedHashSetClassDesc())(eSerializer.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      builder_3thy1n_k$() {
        // Inline function 'kotlin.collections.linkedSetOf' call
        return LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
      }
      builderSize_r1nqpv_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_size_woubt6_k$();
      }
      builderSize_wan9ya_k$(_this__u8e3s4) {
        return this.builderSize_r1nqpv_k$(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_r6oxq1_k$(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      toResult_x7ydem_k$(_this__u8e3s4) {
        return this.toResult_r6oxq1_k$(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_4rloh5_k$(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashSet().new_kotlin_collections_LinkedHashSet_2u8q9r_k$(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_4rloh5_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      checkCapacity_ntq5h1_k$(_this__u8e3s4, size) {
      }
      checkCapacity_4ljkg0_k$(_this__u8e3s4, size) {
        return this.checkCapacity_ntq5h1_k$(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      insert_rxm550_k$(_this__u8e3s4, index, element) {
        _this__u8e3s4.add_utx5q5_k$(element);
      }
      insert_rt7dry_k$(_this__u8e3s4, index, element) {
        return this.insert_rxm550_k$(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'LinkedHashSetSerializer');
    LinkedHashSetSerializerClass = $;
  }
  return LinkedHashSetSerializerClass;
}
var LinkedHashMapSerializerClass;
function LinkedHashMapSerializer() {
  if (LinkedHashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.descriptor_1 = new (LinkedHashMapClassDesc())(kSerializer.get_descriptor_wjt6a0_k$(), vSerializer.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      collectionSize_tcfefw_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_size_woubt6_k$();
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_tcfefw_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      collectionIterator_iaj4x5_k$(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      }
      collectionIterator_l8s4xt_k$(_this__u8e3s4) {
        return this.collectionIterator_iaj4x5_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      builder_3thy1n_k$() {
        return LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
      }
      builderSize_vabndf_k$(_this__u8e3s4) {
        return imul(_this__u8e3s4.get_size_woubt6_k$(), 2);
      }
      builderSize_wan9ya_k$(_this__u8e3s4) {
        return this.builderSize_vabndf_k$(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_48ppgx_k$(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      toResult_x7ydem_k$(_this__u8e3s4) {
        return this.toResult_48ppgx_k$(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_2u7r19_k$(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashMap().new_kotlin_collections_LinkedHashMap_40dkn3_k$(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_2u7r19_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      checkCapacity_q9nvtr_k$(_this__u8e3s4, size) {
      }
      checkCapacity_4ljkg0_k$(_this__u8e3s4, size) {
        return this.checkCapacity_q9nvtr_k$(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'LinkedHashMapSerializer');
    LinkedHashMapSerializerClass = $;
  }
  return LinkedHashMapSerializerClass;
}
var HashSetSerializerClass;
function HashSetSerializer() {
  if (HashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.descriptor_1 = new (HashSetClassDesc())(eSerializer.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      builder_3thy1n_k$() {
        return HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
      }
      builderSize_uktc1i_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_size_woubt6_k$();
      }
      builderSize_wan9ya_k$(_this__u8e3s4) {
        return this.builderSize_uktc1i_k$(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_pk432m_k$(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      toResult_x7ydem_k$(_this__u8e3s4) {
        return this.toResult_pk432m_k$(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_4rloh5_k$(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashSet().new_kotlin_collections_HashSet_4fs03s_k$(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_4rloh5_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      checkCapacity_81yld8_k$(_this__u8e3s4, size) {
      }
      checkCapacity_4ljkg0_k$(_this__u8e3s4, size) {
        return this.checkCapacity_81yld8_k$(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      insert_dbcb3d_k$(_this__u8e3s4, index, element) {
        _this__u8e3s4.add_utx5q5_k$(element);
      }
      insert_rt7dry_k$(_this__u8e3s4, index, element) {
        return this.insert_dbcb3d_k$(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'HashSetSerializer');
    HashSetSerializerClass = $;
  }
  return HashSetSerializerClass;
}
var HashMapSerializerClass;
function HashMapSerializer() {
  if (HashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.descriptor_1 = new (HashMapClassDesc())(kSerializer.get_descriptor_wjt6a0_k$(), vSerializer.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      collectionSize_tcfefw_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_size_woubt6_k$();
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_tcfefw_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      collectionIterator_iaj4x5_k$(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      }
      collectionIterator_l8s4xt_k$(_this__u8e3s4) {
        return this.collectionIterator_iaj4x5_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      builder_3thy1n_k$() {
        return HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      builderSize_xjd9v8_k$(_this__u8e3s4) {
        return imul(_this__u8e3s4.get_size_woubt6_k$(), 2);
      }
      builderSize_wan9ya_k$(_this__u8e3s4) {
        return this.builderSize_xjd9v8_k$(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_rkrg20_k$(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      toResult_x7ydem_k$(_this__u8e3s4) {
        return this.toResult_rkrg20_k$(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_2u7r19_k$(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashMap().new_kotlin_collections_HashMap_gc38m_k$(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_2u7r19_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      checkCapacity_l9cilm_k$(_this__u8e3s4, size) {
      }
      checkCapacity_4ljkg0_k$(_this__u8e3s4, size) {
        return this.checkCapacity_l9cilm_k$(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'HashMapSerializer');
    HashMapSerializerClass = $;
  }
  return HashMapSerializerClass;
}
var ReferenceArraySerializerClass;
function ReferenceArraySerializer() {
  if (ReferenceArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(kClass, eSerializer) {
        super(eSerializer);
        this.kClass_1 = kClass;
        this.descriptor_1 = new (ArrayClassDesc())(eSerializer.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      collectionSize_s9irs3_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_s9irs3_k$((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      collectionIterator_w0595i_k$(_this__u8e3s4) {
        return arrayIterator(_this__u8e3s4);
      }
      collectionIterator_l8s4xt_k$(_this__u8e3s4) {
        return this.collectionIterator_w0595i_k$((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      builder_3thy1n_k$() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      builderSize_j202pb_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_size_woubt6_k$();
      }
      builderSize_wan9ya_k$(_this__u8e3s4) {
        return this.builderSize_j202pb_k$(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_mc1unn_k$(_this__u8e3s4) {
        return toNativeArrayImpl(_this__u8e3s4, this.kClass_1);
      }
      toResult_x7ydem_k$(_this__u8e3s4) {
        return this.toResult_mc1unn_k$(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_o01xzy_k$(_this__u8e3s4) {
        return ArrayList().new_kotlin_collections_ArrayList_603np_k$(asList(_this__u8e3s4));
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_o01xzy_k$((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      checkCapacity_tf6to1_k$(_this__u8e3s4, size) {
        return _this__u8e3s4.ensureCapacity_wr7980_k$(size);
      }
      checkCapacity_4ljkg0_k$(_this__u8e3s4, size) {
        return this.checkCapacity_tf6to1_k$(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      insert_4w10q6_k$(_this__u8e3s4, index, element) {
        _this__u8e3s4.add_dl6gt3_k$(index, element);
      }
      insert_rt7dry_k$(_this__u8e3s4, index, element) {
        return this.insert_4w10q6_k$(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ReferenceArraySerializer');
    ReferenceArraySerializerClass = $;
  }
  return ReferenceArraySerializerClass;
}
var CollectionSerializerClass;
function CollectionSerializer() {
  if (CollectionSerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      collectionSize_y7efpe_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_size_woubt6_k$();
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_y7efpe_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      collectionIterator_5cte45_k$(_this__u8e3s4) {
        return _this__u8e3s4.iterator_jk1svi_k$();
      }
      collectionIterator_l8s4xt_k$(_this__u8e3s4) {
        return this.collectionIterator_5cte45_k$((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
    }
    initMetadataForClass($, 'CollectionSerializer');
    CollectionSerializerClass = $;
  }
  return CollectionSerializerClass;
}
var MapLikeSerializerClass;
function MapLikeSerializer() {
  if (MapLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(keySerializer, valueSerializer) {
        super();
        this.keySerializer_1 = keySerializer;
        this.valueSerializer_1 = valueSerializer;
      }
      readAll_lkk7i3_k$(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var progression = step(until(0, imul(size, 2)), 2);
        var inductionVariable = progression.first_1;
        var last = progression.last_1;
        var step_0 = progression.step_1;
        if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            this.readElement_xcquwd_k$(decoder, startIndex + index | 0, builder, false);
          }
           while (!(index === last));
      }
      readAll_464h0j_k$(decoder, builder, startIndex, size) {
        return this.readAll_lkk7i3_k$(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), startIndex, size);
      }
      readElement_xcquwd_k$(decoder, index, builder, checkIndex) {
        var key = decoder.decodeSerializableElement$default_j0zaoi_k$(this.get_descriptor_wjt6a0_k$(), index, this.keySerializer_1);
        var tmp;
        if (checkIndex) {
          // Inline function 'kotlin.also' call
          var this_0 = decoder.decodeElementIndex_bstkhp_k$(this.get_descriptor_wjt6a0_k$());
          // Inline function 'kotlin.require' call
          if (!(this_0 === (index + 1 | 0))) {
            var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
          }
          tmp = this_0;
        } else {
          tmp = index + 1 | 0;
        }
        var vIndex = tmp;
        var tmp_0;
        var tmp_1;
        if (builder.containsKey_aw81wo_k$(key)) {
          var tmp_2 = this.valueSerializer_1.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$();
          tmp_1 = !(tmp_2 instanceof PrimitiveKind());
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = decoder.decodeSerializableElement_uahnnv_k$(this.get_descriptor_wjt6a0_k$(), vIndex, this.valueSerializer_1, getValue(builder, key));
        } else {
          tmp_0 = decoder.decodeSerializableElement$default_j0zaoi_k$(this.get_descriptor_wjt6a0_k$(), vIndex, this.valueSerializer_1);
        }
        var value = tmp_0;
        // Inline function 'kotlin.collections.set' call
        builder.put_4fpzoq_k$(key, value);
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_xcquwd_k$(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), checkIndex);
      }
      serialize_ag16s_k$(encoder, value) {
        var size = this.collectionSize_kqukvo_k$(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = encoder.beginCollection_9edss2_k$(descriptor, size);
        var iterator = this.collectionIterator_l8s4xt_k$(value);
        var index = 0;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = iterator;
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var k = element.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var v = element.get_value_j01efc_k$();
          var tmp = this.get_descriptor_wjt6a0_k$();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          composite.encodeSerializableElement_isqxcl_k$(tmp, _unary__edvuaz, this.keySerializer_1, k);
          var tmp_0 = this.get_descriptor_wjt6a0_k$();
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          composite.encodeSerializableElement_isqxcl_k$(tmp_0, _unary__edvuaz_0, this.valueSerializer_1, v);
        }
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ag16s_k$(encoder, value);
      }
    }
    initMetadataForClass($, 'MapLikeSerializer');
    MapLikeSerializerClass = $;
  }
  return MapLikeSerializerClass;
}
var CollectionLikeSerializerClass;
function CollectionLikeSerializer() {
  if (CollectionLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(elementSerializer) {
        super();
        this.elementSerializer_1 = elementSerializer;
      }
      serialize_ag16s_k$(encoder, value) {
        var size = this.collectionSize_kqukvo_k$(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = encoder.beginCollection_9edss2_k$(descriptor, size);
        var iterator = this.collectionIterator_l8s4xt_k$(value);
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            composite.encodeSerializableElement_isqxcl_k$(this.get_descriptor_wjt6a0_k$(), index, this.elementSerializer_1, iterator.next_20eer_k$());
          }
           while (inductionVariable < size);
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ag16s_k$(encoder, value);
      }
      readAll_464h0j_k$(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.readElement_36l3ep_k$(decoder, startIndex + index | 0, builder, false);
          }
           while (inductionVariable < size);
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        this.insert_rt7dry_k$(builder, index, decoder.decodeSerializableElement$default_j0zaoi_k$(this.get_descriptor_wjt6a0_k$(), index, this.elementSerializer_1));
      }
    }
    initMetadataForClass($, 'CollectionLikeSerializer');
    CollectionLikeSerializerClass = $;
  }
  return CollectionLikeSerializerClass;
}
function readSize($this, decoder, builder) {
  var size = decoder.decodeCollectionSize_l3mlkk_k$($this.get_descriptor_wjt6a0_k$());
  $this.checkCapacity_4ljkg0_k$(builder, size);
  return size;
}
var AbstractCollectionSerializerClass;
function AbstractCollectionSerializer() {
  if (AbstractCollectionSerializerClass === VOID) {
    class $ {
      merge_4lx7x7_k$(decoder, previous) {
        var tmp1_elvis_lhs = previous == null ? null : this.toBuilder_5lxc6t_k$(previous);
        var builder = tmp1_elvis_lhs == null ? this.builder_3thy1n_k$() : tmp1_elvis_lhs;
        var startIndex = this.builderSize_wan9ya_k$(builder);
        var compositeDecoder = decoder.beginStructure_yljocp_k$(this.get_descriptor_wjt6a0_k$());
        if (compositeDecoder.decodeSequentially_xlblqy_k$()) {
          this.readAll_464h0j_k$(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
        } else {
          $l$loop: while (true) {
            var index = compositeDecoder.decodeElementIndex_bstkhp_k$(this.get_descriptor_wjt6a0_k$());
            if (index === -1)
              break $l$loop;
            this.readElement$default_2bdt9n_k$(compositeDecoder, startIndex + index | 0, builder);
          }
        }
        compositeDecoder.endStructure_1xqz0n_k$(this.get_descriptor_wjt6a0_k$());
        return this.toResult_x7ydem_k$(builder);
      }
      deserialize_sy6x50_k$(decoder) {
        return this.merge_4lx7x7_k$(decoder, null);
      }
      readElement$default_2bdt9n_k$(decoder, index, builder, checkIndex, $super) {
        checkIndex = checkIndex === VOID ? true : checkIndex;
        var tmp;
        if ($super === VOID) {
          this.readElement_36l3ep_k$(decoder, index, builder, checkIndex);
          tmp = Unit_instance;
        } else {
          tmp = $super.readElement_36l3ep_k$.call(this, decoder, index, builder, checkIndex);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer()]);
    AbstractCollectionSerializerClass = $;
  }
  return AbstractCollectionSerializerClass;
}
var PrimitiveArraySerializerClass;
function PrimitiveArraySerializer() {
  if (PrimitiveArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(primitiveSerializer) {
        super(primitiveSerializer);
        this.descriptor_1 = new (PrimitiveArrayDescriptor())(primitiveSerializer.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      builderSize_o7j3ed_k$(_this__u8e3s4) {
        return _this__u8e3s4.get_position_cjjt7w_k$();
      }
      builderSize_wan9ya_k$(_this__u8e3s4) {
        return this.builderSize_o7j3ed_k$(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      toResult_a2kawh_k$(_this__u8e3s4) {
        return _this__u8e3s4.build_boe8ts_k$();
      }
      toResult_x7ydem_k$(_this__u8e3s4) {
        return this.toResult_a2kawh_k$(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      checkCapacity_m26r65_k$(_this__u8e3s4, size) {
        return _this__u8e3s4.ensureCapacity_mq7liq_k$(size);
      }
      checkCapacity_4ljkg0_k$(_this__u8e3s4, size) {
        return this.checkCapacity_m26r65_k$(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      collectionIterator_7wnbtc_k$(_this__u8e3s4) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use writeContents instead';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      collectionIterator_l8s4xt_k$(_this__u8e3s4) {
        return this.collectionIterator_7wnbtc_k$(_this__u8e3s4);
      }
      insert_hsr581_k$(_this__u8e3s4, index, element) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use Builder.append instead';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      insert_rt7dry_k$(_this__u8e3s4, index, element) {
        return this.insert_hsr581_k$(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
      builder_3thy1n_k$() {
        return this.toBuilder_5lxc6t_k$(this.empty_1lj7f1_k$());
      }
      serialize_tb1dm5_k$(encoder, value) {
        var size = this.collectionSize_kqukvo_k$(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.descriptor_1;
        var composite = encoder.beginCollection_9edss2_k$(descriptor, size);
        this.writeContent_wekas_k$(composite, value, size);
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_tb1dm5_k$(encoder, value);
      }
      serialize_ag16s_k$(encoder, value) {
        return this.serialize_tb1dm5_k$(encoder, value);
      }
      deserialize_sy6x50_k$(decoder) {
        return this.merge_4lx7x7_k$(decoder, null);
      }
    }
    initMetadataForClass($, 'PrimitiveArraySerializer');
    PrimitiveArraySerializerClass = $;
  }
  return PrimitiveArraySerializerClass;
}
var PrimitiveArrayBuilderClass;
function PrimitiveArrayBuilder() {
  if (PrimitiveArrayBuilderClass === VOID) {
    class $ {
      ensureCapacity$default_4tzhe_k$(requiredCapacity, $super) {
        requiredCapacity = requiredCapacity === VOID ? this.get_position_cjjt7w_k$() + 1 | 0 : requiredCapacity;
        var tmp;
        if ($super === VOID) {
          this.ensureCapacity_mq7liq_k$(requiredCapacity);
          tmp = Unit_instance;
        } else {
          tmp = $super.ensureCapacity_mq7liq_k$.call(this, requiredCapacity);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayBuilder');
    PrimitiveArrayBuilderClass = $;
  }
  return PrimitiveArrayBuilderClass;
}
//region block: exports
export {
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  HashMapSerializer as HashMapSerializer10v33y6rrzgrh,
  HashSetSerializer as HashSetSerializer1nieavib0jif1,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  PrimitiveArrayBuilder as PrimitiveArrayBuilder1tzna3i4eqw54,
  PrimitiveArraySerializer as PrimitiveArraySerializer6xcmeltdozbx,
  ReferenceArraySerializer as ReferenceArraySerializer3juj1vqolxkrs,
};
//endregion

//# sourceMappingURL=CollectionSerializers.mjs.map
